import styled from 'styled-components';
import { Icon } from 'react-materialize';

export default styled(Icon)`
  vertical-align: middle;
`;
